import { blue } from '@ant-design/colors';
import { Form, Modal, Row, Space, message } from 'antd';
import Dragger from 'antd/es/upload/Dragger';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { AsyncStates } from 'src/constants';
import { importMultipleWorkOrdersClear, importMultipleWorkOrdersRequest } from 'src/store/actions/files';
import { StoreState } from 'src/store/configureStore';
import { StyledButton } from 'src/styled_components/StyledButton';
import useTranslate from 'src/utils/useTranslate'

const UploadMultipleWo = () => {
    const [t] = useTranslate()
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const dispatch = useDispatch()
    const [form] = Form.useForm();
    const current = useSelector((state: StoreState) => state.projects.current)
    const uploadMultipleStatus = useSelector((state: StoreState) => state.files.uploadWorkOrderFile.status)
    const importWoStatus = useSelector((state: StoreState) => state.files.uploadWorkOrderFile.status)
    const configs = useSelector((state: StoreState) => state.configs.features)
    const [file, setFile] = useState<any>();

    const uploadProps = {
        onRemove: (record: any) => {
            setFile(null);
        },
        beforeUpload: (record: any) => {
            if (record.name.split(".").pop() === "xlsx") {
                setFile(record)
            } else message.error(t("dataUpload.selectedFileDesc"))
            return false
        },
        multiple: false,
        fileList: !!file ? [file] : [],
    }

    useEffect(() => {
        if (importWoStatus === AsyncStates.SUCCESS) {
            dispatch(importMultipleWorkOrdersClear());
            message.success(t("dataManagement.importWoProcessing"));
            // history.push(`/projects/details/${currentProject}`);
        } else if (importWoStatus === AsyncStates.ERROR) {
            dispatch(importMultipleWorkOrdersClear());
            message.error(`${t("common.somethingWentWrong")}, ${t("common.tryAgain")}`);
        }
    }, [importWoStatus, current, dispatch, t]);

    useEffect(() => {
        if (uploadMultipleStatus === AsyncStates.SUCCESS) {
            setFile(null)
            setIsOpen(false)
        }
    }, [uploadMultipleStatus])


    const importData = () => {
        const payload = new FormData();
        payload.append("file", file);
        payload.append("project_id", current)
        dispatch(importMultipleWorkOrdersRequest(payload));
    }


    return (
        <>
            {Boolean(configs?.work_order_upload) &&
                <StyledButton type={"primary"} onClick={(e) => {
                    e.stopPropagation()
                    setIsOpen(true)
                }}
                    className={"project__dropdown__btn"}>
                    {t("projects.importMultipleWOs")}
                </StyledButton>
            }
            <Modal
                maskClosable={false}
                title={t("projects.importMultipleWOs")}
                open={isOpen}
                onCancel={(e) => {
                    e.stopPropagation()
                    setFile(null)
                    setIsOpen(false)
                }}
                footer={null}
            >
                <Space direction='vertical' style={{ width: "100%" }}>
                    <Form
                        name="generate-work-order"
                        form={form}
                        initialValues={{ work_order_type: "new" }}
                        requiredMark={false}
                        layout="vertical"
                        onFinish={importData}
                    >
                        <Form.Item
                            name="file"
                            required
                            rules={[{ required: true, message: t("common.required") }]}
                        >
                            <Dragger {...uploadProps}>
                                <p
                                    style={{ paddingTop: 30, paddingBottom: 30 }}
                                    className="ant-upload-text"
                                >
                                    {t("dataUpload.dragnDrop")}
                                    <span style={{ color: blue[5] }}>
                                        {" "}
                                        {t("dataUpload.selectFile")}
                                    </span>
                                </p>
                            </Dragger>
                        </Form.Item>
                        <Row justify={"end"}>
                            <StyledButton
                                type="primary"
                                htmlType="submit"
                                style={{ marginTop: 40 }}
                                disabled={
                                    uploadMultipleStatus === AsyncStates.LOADING || !file
                                        ? true
                                        : false

                                }
                                loading={
                                    uploadMultipleStatus === AsyncStates.LOADING
                                        ? true
                                        : false
                                }
                            >
                                {t("common.import")}
                            </StyledButton>
                        </Row>
                    </Form>
                </Space>
            </Modal>

        </>

    )
}

export default UploadMultipleWo